/**
 * scroll-carousel.js — PageFly カルーセルのネイティブ置換用の共通最小実装。
 * マークアップ規約:
 *   <div data-carousel [data-loop]> ... slides (scroll-snap) ... </div>
 *   <button data-carousel-prev></button> / <button data-carousel-next></button>
 *   （prev/next は data-carousel と同じ親要素内に置く）
 * CSS 側で display:flex / overflow-x:auto / scroll-snap-type:x mandatory を定義すること。
 * JS が無効でも scroll-snap によりスワイプ/横スクロールは機能する（プログレッシブ）。
 */
(function () {
  function init(root) {
    root.querySelectorAll('[data-carousel]').forEach(function (track) {
      if (track.dataset.carouselReady) return;
      track.dataset.carouselReady = '1';
      var wrap = track.parentElement;
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      var loop = track.hasAttribute('data-loop');
      if (!prev && !next) return;

      function step(dir) {
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft + dir * track.clientWidth;
        if (loop) {
          if (dir > 0 && track.scrollLeft >= max - 4) x = 0;
          if (dir < 0 && track.scrollLeft <= 4) x = max;
        }
        track.scrollTo({ left: x, behavior: 'smooth' });
      }
      function update() {
        if (loop) return;
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
        if (next) next.toggleAttribute('disabled', track.scrollLeft >= max - 4);
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
